import { useCallback, useEffect, useRef } from 'react';

const useIdleTimeout = (enabled: boolean, onTimeout: () => void, idleTimeout: number = 15000): void => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimeout = useCallback((): void => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => onTimeout(), idleTimeout);
  }, [idleTimeout, onTimeout]);

  useEffect(() => {
    if (!enabled) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      return;
    }

    resetTimeout();

    const events = ['click'];
    events.forEach((event) => window.addEventListener(event, resetTimeout));

    // eslint-disable-next-line consistent-return
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimeout));
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [enabled, resetTimeout]);
};

export default useIdleTimeout;
